
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"84","height":"77","viewBox":"0 0 84 77"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"d":"M0 0h84v77H0z"}})])]),_c('g',{attrs:{"data-name":"Group 2","fill":"none","stroke":"#55534f","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"3","clip-path":"url(#a)"}},[_c('path',{attrs:{"data-name":"Path 962","d":"M61.485 44.772a7.136 7.136 0 00.469-4.748c-.65-2.978-5.134-5.661-7.607-6.978s-9.7-4.353-11.188-5.193a9.072 9.072 0 01-3.242-3.3c-.4-.86-1.263-.994-3.009 1.64s-.995 4.783.4 6.986-.78 2.956-1.451 3.064a35.953 35.953 0 00-7.525 2.875c-4.281 2.159-3.366 3.431-2.811 5.653"}}),_c('path',{attrs:{"data-name":"Path 963","d":"M69.897 44.772H14.708a.718.718 0 00-.363 1.329l12.085 7.13a5.178 5.178 0 002.658.725h26.429a5.176 5.176 0 002.658-.725l12.085-7.13a.718.718 0 00-.363-1.329z"}})])])
          )
        }
      }
    